import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../node_modules/lit-html/lit-html.js';
import '../../../../node_modules/lit-element/lit-element.js';
import { css as i } from '../../../../node_modules/lit-element/node_modules/@lit/reactive-element/css-tag.js';

var css_248z = i`:host{width:100%}.country-link{align-items:center;cursor:pointer;display:flex}::slotted(a){background-image:none;border-radius:4px;color:inherit;color:#1d1b1f;font-size:18px;font-weight:600;line-height:24px;text-decoration:none;transition:.3s linear}::slotted(a:hover){background-position:100%}::slotted(img){height:32px;margin-right:16px;width:32px}.rtl ::slotted(img){margin-left:16px;margin-right:0}`;

export { css_248z as default };
